import AboutUsMobile from "../../mobile/about";

const AboutUs = () => {
  return <div className="w-full">
    <AboutUsMobile />
  </div>;
};

export default AboutUs;
